import { gql } from '@apollo/client';

export const RUN_BID_OPTIMIZATION = gql`
  mutation RunBidOptimization($saleId: ID!, $round: Int!) {
    runBidOptimization(sale_id: $saleId, round: $round) {
      __typename
      sale_id
      round
      version
    }
  }
`;
